import { render, staticRenderFns } from "./ExternalPurchaseRequests.html?vue&type=template&id=072b4a83&external"
import script from "./ExternalPurchaseRequests.js?vue&type=script&lang=js&external"
export * from "./ExternalPurchaseRequests.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports